var _text, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevfest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "600px",
    height: "200px",
    viewBox: "0 0 600 200",
    enableBackground: "new 0 0 600 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 316.5547 83.2734)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fill: "#547DBF",
    fontFamily: "'GoogleSansDisplay-Regular'",
    fontSize: 55.4911
  }, "DevFest"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 66.589,
    fill: "#547DBF",
    fontFamily: "'GoogleSansDisplay-Regular'",
    fontSize: 55.4911
  }, "Rift Valley"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#547DBF",
    d: "M145.715,151.259c-3.701,6.419-10.431,10.009-17.343,10.009c-3.389,0-6.83-0.866-9.987-2.686 l-70.249-40.56c-9.565-5.524-12.846-17.761-7.32-27.323c3.708-6.42,10.429-10.009,17.342-10.009c3.39,0,6.831,0.866,9.984,2.686 l70.252,40.552C147.966,129.455,151.24,141.687,145.715,151.259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#547DBF",
    d: "M180.916,50.133c3.705-6.416,10.428-10.003,17.341-10.003c3.393,0,6.831,0.864,9.986,2.682l70.252,40.565 c9.562,5.516,12.842,17.756,7.321,27.326c-3.713,6.415-10.433,10.001-17.345,10.001c-3.392,0-6.833-0.859-9.984-2.681 l-70.252-40.56C178.669,71.94,175.39,59.707,180.916,50.133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#547DBF",
    d: "M138.395,77.462L103.06,97.858L70.601,79.12c-2.96-1.709-6.233-2.778-9.603-3.176l57.394-33.133 c3.147-1.818,6.588-2.682,9.984-2.682c6.913,0,13.637,3.587,17.338,10.003C151.24,59.701,147.963,71.94,138.395,77.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#547DBF",
    d: "M188.235,123.937l35.336-20.403l32.46,18.735c2.955,1.713,6.232,2.793,9.599,3.178l-57.392,33.136 c-3.15,1.819-6.588,2.681-9.981,2.681c-6.913,0-13.636-3.58-17.341-9.999C175.39,141.687,178.669,129.458,188.235,123.937"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevfest);
export default __webpack_public_path__ + "static/media/devfest.f80be3c40f2f9e4cec8eddb96de8b852.svg";
export { ForwardRef as ReactComponent };